import Seo from 'components/Layout/components/Seo';

const LegalPageSeo = ({ title, data, routeName }) => (
  <Seo
    title={title}
    description={data.seoDescription}
    route={{ name: routeName }}
  />
);

export default LegalPageSeo;
